import {
  FaArrowRotateLeft,
  FaArrowRotateRight,
  FaAnglesLeft,
  FaAnglesRight
} from "react-icons/fa6";
import {FaCrop, FaPause, FaPlay} from "react-icons/fa";
import * as Slider from "@radix-ui/react-slider";
import Button from "../../../../../../components/button/button.jsx";
import DropdownButton from "../../../../../../components/button/dropdown-button.jsx";
import {garrisonTimelineModes} from "../../../utils/garrison-timeline-utils.js";
import {PLAYBACK_SPEEDS} from "../../../hooks/useTimelineAnimation.js";
import SHorizontalSpacing from "../../../../../../components/icons/horizontal-spacing.jsx";

const mapOptions = [
  {value: "60", label: "1 minuto"},
  {value: "300", label: "5 minutos"},
  {value: "600", label: "10 minutos"},
  {value: "1800", label: "30 minutos"},
  {value: "3600", label: "60 minutos"}
];

const timelineOptions = [
  {value: "10", label: "10 segundos"},
  {value: "30", label: "30 segundos"},
  {value: "60", label: "1 minuto"},
  {value: "3600", label: "1 hora"}
];

const GarrisonTimelineControlPanel = ({
  mode,
  isPlaying,
  onTogglePlay,
  isCropMode,
  onToggleCrop,
  speedIndex,
  setSpeedIndex,
  stepSeconds,
  setStepSeconds,
  onStepForward,
  onStepBackward,
  onRestart
}) => {
  const isMap = mode === garrisonTimelineModes.map;
  const isRoute = mode === garrisonTimelineModes.route;
  const isTimeline = mode === garrisonTimelineModes.timeline;
  const isMapPlayback = isMap || isRoute;
  const controlClassName = "h-full flex items-center justify-between " + (isTimeline ? "opacity-50 pointer-events-none" : "");

  return (
    <div className={controlClassName}>
      <div className="flex items-center gap-1">
        <Button target="primary-outline" title={isTimeline ? "Reprodução disponível apenas no mapa e em rotas" : isPlaying ? "Pausar" : "Play"} onClick={onTogglePlay} className="h-[34px]! w-[38px]! px-0! flex items-center justify-center rounded">
          {isPlaying ? <FaPause size={18} color="#063a6c" /> : <FaPlay size={18} color="#063a6c" />}
        </Button>
        <Button
          title="Ajustar período de reprodução"
          target="primary-outline"
          onClick={onToggleCrop}
          className={`h-[28px]! w-[28px]! px-0! flex items-center justify-center rounded transition-colors ${isCropMode ? "!bg-red-50 !border-red-500" : ""} focus:!ring-0`}
        >
          <SHorizontalSpacing color={isCropMode ? "#ef4444" : "#063a6c"} />
        </Button>
      </div>

      <div className="flex flex-col items-center gap-1 justify-center h-full">
        <div className="flex items-center gap-1">
          <Button target="primary-outline" title="Recuar" onClick={onStepBackward} className="h-[26px]! w-[30px]! px-0! flex items-center justify-center rounded">
            <FaAnglesLeft size={14} color="#063a6c" />
          </Button>

          <div className="w-[110px]">
            {(() => {
              const currentOptions = isMapPlayback ? mapOptions : timelineOptions;
              const currentLabel = currentOptions.find(option => option.value === String(stepSeconds))?.label || "Selecione";

              return (
                <DropdownButton
                  menuWidth={130}
                  align="left"
                  buttonClassName="w-full focus:outline-none focus:ring-0"
                  menuClassName="p-1.5 flex flex-col gap-0.5 shadow-lg border-[#E5E7EB]"
                  itemClassName="rounded-md px-3 py-1.5 text-[13px]"
                  buttonContent={
                    <div className="flex h-[26px] w-full items-center justify-center rounded border border-gray-300 px-2 text-[12px] text-gray-700 bg-white transition-colors hover:bg-blue-50 focus:outline-none focus:ring-0">
                      <span className="truncate">{currentLabel}</span>
                    </div>
                  }
                  items={currentOptions.map(option => {
                    const isSelected = String(stepSeconds) === option.value;

                    return {
                      label: option.label,
                      onClick: () => setStepSeconds(option.value),
                      className: isSelected
                        ? "bg-[#e2e8f0] font-medium text-gray-800"
                        : "text-gray-600 hover:bg-[#f1f5f9]"
                    };
                  })}
                />
              );
            })()}
          </div>

          <Button target="primary-outline" title="Avançar" onClick={onStepForward} className="h-[26px]! w-[30px]! px-0! flex items-center justify-center rounded">
            <FaAnglesRight size={14} color="#063a6c" />
          </Button>
        </div>

        <div className="flex flex-col items-center justify-center pt-2">
          <div className="flex w-[100px] justify-between text-[9px] text-[#94a3b8] px-5">
            {PLAYBACK_SPEEDS.slice(1, 5).map(speed => <span key={speed}>{speed}x</span>)}
          </div>
          <div className="flex items-center gap-2 text-[11px] text-gray-400 font-medium w-full">
            <span>{PLAYBACK_SPEEDS[0]}x</span>
            <Slider.Root
              className="relative flex items-center select-none touch-none w-[100px] h-4"
              title="Velocidade de reprodução"
              value={[speedIndex]}
              onValueChange={([value]) => setSpeedIndex(value)}
              max={5}
              min={0}
              step={1}
            >
              <Slider.Track className="bg-gray-200 relative grow rounded-full h-1.5">
                <Slider.Range className="absolute bg-[#3b82f6] rounded-full h-full" />
              </Slider.Track>
              <Slider.Thumb className="block w-3.5 h-3.5 bg-[#063a6c] rounded-full shadow cursor-pointer outline-none hover:scale-110 transition-transform" />
            </Slider.Root>
            <span>{PLAYBACK_SPEEDS[5]}x</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GarrisonTimelineControlPanel;
